<template>
  <nav class="sticky">
    <div class="logo">
      <router-link to="/"
        ><img alt="aye logo" src="../assets/LOGO-aye1.png"
      /></router-link>
    </div>

    <div class="menu">
      <div
        class="dropdown"
        @mouseenter="openDropdown"
        @mouseleave="closeDropdown"
      >
        <router-link to="/home">works</router-link>
        <!-- <ul class="submenu">
          <li><router-link to="/web">www</router-link></li>
          <li><router-link to="/design">dsgn</router-link></li>
        </ul> -->
      </div>
      <router-link to="/t-a-e">t.a.e. </router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: "HeaderNavigation",
  data() {
    return {
      isDropdownOpen: false,
    };
  },
  methods: {
    openDropdown() {
      this.isDropdownOpen = true;
    },
    closeDropdown() {
      this.isDropdownOpen = false;
    },
    async scrollToSection(id) {
      if (this.$route.path !== "/home") {
        await this.$router.push("/home");
        await this.$nextTick();
        setTimeout(() => this.doScroll(id), 100);
      } else {
        this.doScroll(id);
      }
    },
    doScroll(id) {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
  },
};
</script>

<style scoped>
nav {
  padding: 30px;
  background-color: #d3d3d4;
  background-color: #e7fdf0;
  background: linear-gradient(to bottom, #07009a, #0601d0);
  background: linear-gradient(to bottom, #17213c, #1e2b51);
  color: #221f21;
  height: 55px;
  /* opacity: 0.7; */
}
nav a {
  font-weight: 500;
  font-size: 1rem;
  padding: 0 15px;
  color: #221f21;
  color: #fefeff;
  text-decoration: none;
  margin-left: 30px;
}
nav a.router-link-exact-active {
  color: #221f21;
  color: #fefeff;
  text-transform: uppercase;
}
.sticky {
  position: sticky;
  top: 0;
  z-index: 1000;
}
.logo img {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 50px;
  top: 35px;
  z-index: 1000;
  opacity: 0.75;
}
.menu {
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-right: 80px;
  font-weight: 500;
  font-size: 1rem;
  padding: 0 10px;
  color: var(--hellblau);
  text-decoration: none;
}
.menu > li {
  display: inline-block;
  position: relative;
}
.menu > li:hover .submenu {
  display: block;
}
.menu > a,
.menu .dropdown > a {
  position: relative;
}

.menu > a::after,
.menu .dropdown > a::after {
  content: "";
  position: absolute;
  bottom: -2px;
  right: 15px;
  left: auto;
  height: 1.5px;
  width: 0;
  background-color: #221f21;
  background-color: #fefeff;
  transition: width 0.3s ease;
}

.menu > a:hover::after,
.menu .dropdown > a:hover::after {
  width: calc(100% - 30px);
}
nav a.router-link-exact-active::after {
  width: 100%;
}
.menu .dropdown {
  cursor: pointer;
  padding-right: 15px;
  padding-left: 15px;
}
.submenu {
  display: none;
  position: absolute;
  background-color: transparent;
  color: white;
  padding: 10px;
  list-style-type: none;
  margin-top: -8px;
  text-align: left;
}
.submenu a {
  font-size: 0.9rem;
  position: relative;
  display: inline-block;
}

.submenu a::after {
  content: "";
  position: absolute;
  bottom: -2px;
  right: 0;
  height: 1.5px;
  width: 0;
  background-color: #221f21;
  transition: width 0.3s ease;
}

.submenu a:hover::after {
  width: 100%;
}
.dropdown:hover .submenu {
  display: block;
}
/* .submenu a:hover {
  color: #fff;
} */
li span {
  font-size: 0.9rem;
}
@media (max-width: 600px) {
  nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    height: auto;
  }

  .logo img {
    position: static;
    width: 40px;
    height: 40px;
  }

  .menu {
    margin-right: 0;
    gap: 0;
  }

  nav a {
    margin-left: 0;
    padding: 0 8px;
    font-size: 0.85rem;
  }
}
</style>
